module.exports = __webpack_public_path__ + "img/pluto.d652c098.svg";